import { render, staticRenderFns } from "./UnitsPerHourChart.vue?vue&type=template&id=baf40172&"
import script from "./UnitsPerHourChart.vue?vue&type=script&lang=js&"
export * from "./UnitsPerHourChart.vue?vue&type=script&lang=js&"
import style0 from "./UnitsPerHourChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports